/**
 * Thin wrapper: re-exports shared groupAndMap/combineMeetings from components/meetings
 * and binds mapNodeToMeeting so callers keep the legacy 3-arg groupAndMap(meetings, publisherTZ, hasMsTeamsFlag).
 */
import {
  combineMeetings as combineMeetingsShared,
  groupAndMap as groupAndMapShared
} from 'components/meetings/utils'

import { mapNodeToMeeting } from '../../utils'

export { combineMeetingsShared as combineMeetings }

export const groupAndMap = (meetings, publisherTZ, hasMsTeamsFlag = false) => groupAndMapShared(
  meetings,
  publisherTZ,
  hasMsTeamsFlag,
  mapNodeToMeeting
)
